<script>
	import { user } from './stores.js';
    import config from "./../config.js";
    import Drawer from './components/Drawer.svelte';

	let username = '';
    let password = '';
    export let redirectTo;

	function requestToken(username, password) {
      const { login } = config;
      let headers = new Headers();
      headers.set("Content-Type", "application/x-www-form-urlencoded");
      return fetch(login["url"], {
        headers: headers,
        method: "POST",
        body: "username=" + username + "&password=" + password,
        credentials: "include"
      })
        .then(res => res.json())
        .catch(error => {
          console.error(error);
          this.set({ error: error });
        });
    }

	function login() {
        if (!username || !password) {
            alert("Please enter username and password")
        }
		requestToken(username, password).then(data => {
            user.set(
                {
                    "username": username,
                    "token": data["access_token"],
                    "expiry": (new Date().getTime() + (parseInt(data["expires_in"], 10)*1000))
                }
            );
            window.location.assign(redirectTo ? redirectTo : "#home");
        });
        return false;
	}
</script>

<style>
input[type="text"], 
input[type="password"] {
    width: 25%;
    display: block;
}
@media only screen and (max-width: 600px) {
    
    input[type="text"], 
    input[type="password"] {
        width: 100%;
    }
}
</style>
<Drawer />

<div class="container">
<form on:submit|preventDefault={login}>
    <input bind:value={username} placeholder="Username" type="text" autocomplete="username">
    <input bind:value={password} placeholder="Password" type="password" autocomplete="current-password">
    <input type="submit" value="Login" />
</form>
</div>
